import crypto from "crypto";
// import jwt from "jsonwebtoken";
import { Buffer } from "buffer";
import jwtEncode from "jwt-encode";
import Logger from './Logger';


export default class Utils {
  static JWT_HEADER = '{"alg":"HS256","typ":"JWT"}';

  static b64decode(strEncoded) {
    return Buffer.from(strEncoded, "base64").toString("utf-8");
  }

  static toHexString(data) {
    return Buffer.from(data).toString("hex");
    // return data.toString("hex");
  }

  static JWT = class {
    constructor(token) {
      const parts = token.split(".");
      this.header = Utils.b64decode(parts[0]);
      this.data = Utils.b64decode(parts[1]);
      this.signature = Utils.b64decode(parts[2]);
    }
  };

  static createJwt(data) {
    Logger.log("CreateJWT:", this.toHexString(data));

    const token = jwtEncode({ data: data }, "secret");
    Logger.log("Generated JWT:", token);
    return token;

    // const jwtToken = jwt.sign({ data: data }, "secret", {
    //   algorithm: "HS256",
    // });
    // Logger.log("JWT : - ", jwtToken);
    // return jwtToken;
  }

  static generateKey(seed) {
    return crypto.createSecretKey(Buffer.from(seed));
  }

  static encryptMsg(bytes, key) {
    const iv = Buffer.from("5284245V4A6HZ7eH"); // Initialization vector
    const cipher = crypto.createCipheriv("aes-256-cbc", key, iv); // Assuming a 256-bit key
    Logger.log("CYCPHER", cipher);

    cipher.setAutoPadding(false); // Disable padding to mimic "NoPadding"
    const cipherText = Buffer.concat([
      cipher.update(Buffer.from(bytes)),
      cipher.final(),
    ]);
    Logger.log("ENC KEY:", key.toString("hex"));
    Logger.log("ENC FRAME:", cipherText.toString("hex"));
    return cipherText;
  }

  static decryptMsg(cipherText, key) {
    const iv = Buffer.from("5284245V4A6HZ7eH"); // Same IV as encryption
    const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv);

    decipher.setAutoPadding(false); // Must match encryption config

    const decrypted = Buffer.concat([
      decipher.update(cipherText),
      decipher.final(),
    ]);

    Logger.log("DEC KEY:", key.toString("hex"));
    Logger.log("DEC FRAME:", decrypted.toString("hex"));

    return decrypted;
  }

  static async createKey(sdkCode, transId, token) {
    Logger.log("CreateKey..", token.length, token);

    const i = token.lastIndexOf(".") + 1;
    const b = token.substring(i, i + 44);
    const tran = Buffer.alloc(4);
    tran.writeUInt32LE(transId, 0);

    const key = Buffer.concat([sdkCode, tran, Buffer.from(b)]);
    Logger.log("CreateKey HEX:", key.toString("hex"));

    const digest = crypto.createHash("sha256").update(key).digest();
    Logger.log("CreateKey HASHED:", digest.toString("hex"));

    return digest;
  }
}
